import { Link, useLocation } from "react-router-dom";
import { Search, ShoppingBag, Plus, MessagesSquare, Users } from "lucide-react";
import { useAuth } from "@/lib/auth-context";

// Dolny pasek nawigacji na mobile (styl Vinted). Widoczny tylko dla zalogowanych
// i tylko na ekranach < md. Ukryty na /add-kit (nie przykrywa formularza).
// Na /wiadomosci jest widoczny — rezerwa w App.tsx trzyma miejsce nad paskiem.
export default function BottomNav() {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return null;

  const hiddenPrefixes = ["/add-kit"];
  if (hiddenPrefixes.some((p) => location.pathname === p || location.pathname.startsWith(p + "/"))) {
    return null;
  }

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  const items = [
    { to: "/explore", label: "Przeglądaj", Icon: Search },
    { to: "/na-sprzedaz", label: "Na sprzedaż", Icon: ShoppingBag },
    { to: "/pogadajmy", label: "Pogadajmy", Icon: MessagesSquare },
    { to: "/collectors", label: "Kolekcjonerzy", Icon: Users },
    { to: "/add-kit", label: "Dodaj", Icon: Plus },
  ];

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 border-t bg-surface/95 backdrop-blur-md md:hidden"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 10px)" }}
      aria-label="Nawigacja mobilna"
    >
      <div className="grid grid-cols-5">
        {items.map(({ to, label, Icon }) => (
          <Link
            key={to}
            to={to}
            className={`flex flex-col items-center gap-0.5 py-2 text-[11px] font-medium ${
              isActive(to) ? "text-primary" : "text-muted-foreground"
            }`}
          >
            <Icon className="h-5 w-5" />
            {label}
          </Link>

        ))}
      </div>
    </nav>
  );
}
